module.exports = __webpack_public_path__ + "img/farzana-christopher-68.ae71df61.jpg";